import 'components/Project/shared/ProjectHeader/ProjectHeader.scss'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import LanguageSelector from 'components/shared/SiteHeader/LanguageSelector/LanguageSelector'
import { themeClassName } from 'helpers/Project'
import PropTypes from 'prop-types'
import React from 'react'
import { withNamespaces } from 'react-i18next'

import './ProjectNotTranslated.scss'

const languageDropdownFilter = (locales, availableLocales) => {
  let options = {}
  availableLocales.forEach((x) => (options[x] = locales[x]))
  return options
}

const ProjectNotTranslated = ({
  project: { content, availableLocales },
  t,
}) => (
  <div>
    <HtmlHead title={`${content.title}`} />
    <div className={`c-project ${themeClassName(content.theme)}`}>
      <header className="c-project-header-wrapper">
        <div className="c-project-header">
          <div className="c-project-header__info">
            <h1 className="c-project-header__title o-type-display-large">
              {content.title}
            </h1>
          </div>

          <figure className="c-project-header__illustration">
            <div className="c-project-header__decoration" />
            <img
              alt=""
              className="c-project-header__image"
              src={content.heroImage}
            />
          </figure>
        </div>
      </header>
      <div className="o-container u-mv-x3">
        <div className="c-project-steps c-project-steps__not-translated">
          <div className="c-project-steps__wrapper">
            <h2>
              {t('project.not-translated.not-available')} —{' '}
              <a href="https://www.raspberrypi.org/translate/">
                {t('project.not-translated.help-us')}!
              </a>
            </h2>
            <div className="u-mv-x3">
              {t('project.not-translated.alternatively')}!
            </div>
            <div className="u-pb-x6">
              <LanguageSelector
                filter={(locales) => {
                  return languageDropdownFilter(locales, availableLocales)
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

ProjectNotTranslated.propTypes = {
  project: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

export default withNamespaces('translations')(ProjectNotTranslated)
